import React from 'react';

const Subscription: React.FC = () => {
  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold mb-2">Subscription Plans</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Text Companion: Text conversations with Emotional Intelligence</li>
        <li>Voice Connect: Voice messages and additional features</li>
        <li>All plans start with a 7-day free trial</li>
        <li>Subscription fees are billed in advance</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Cancellation & Refunds</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Cancel anytime via the link in your subscription confirmation email or by emailing support@feelheard.me</li>
        <li>5-conversation satisfaction guarantee</li>
        <li>Prorated refunds for unused service periods</li>
      </ul>
    </div>
  );
};

export default Subscription;